
$(document).ready(function(){

	var $window = $(window);
    var $document = $(document);


	 /* QUIZ-DCE */
        var $quizcarousel = $('#quiz-carousel');
        var imagewidth = $quizcarousel.attr('data-imagewidth');
        var showdirectional = $quizcarousel.attr('data-showdirectional');

        // always on - hide via CSS for desktop only
        if(showdirectional == '1'){
            showdirectional = true;
        }else{
            showdirectional = true
        }
        var maxitems = $quizcarousel.attr('data-maxitems');
        console.log(maxitems);

        // tiny helper function to add breakpoints
        function getGridSize() {

            // if (window.innerWidth < 1250){
            //     $('#quiz-carousel').css('width', 'inherit');
            // } else {
            //     $('#quiz-carousel').width($quizcarousel.find('.slide').length * imagewidth);
            // }
            if(maxitems > 0) {

                if( window.innerWidth < 1250 ){
                    return 1;
                }

                return maxitems;
            }else{
                if( window.innerWidth < 1250 ){
                    return 1;
                }
                $('#quiz-carousel').width($quizcarousel.find('.slide').length * (imagewidth + 15) - 15);
                maxitems = 5;
                return maxitems;
            }


            // return (window.innerWidth < 1250) ? 1 : 0;
        }




        // BITV/WCAG: Add accessible text to navigation links
        function addQuizNavigationLabels() {
            $('#quiz-carousel .flex-direction-nav .flex-prev').each(function() {
                var $link = $(this);
                if (!$link.attr('aria-label')) {
                    $link.attr('aria-label', 'Vorherige Frage');
                }
            });
            $('#quiz-carousel .flex-direction-nav .flex-next').each(function() {
                var $link = $(this);
                if (!$link.attr('aria-label')) {
                    $link.attr('aria-label', 'Nächste Frage');
                }
            });
        }

        // The slider being synced must be initialized first
        $quizcarousel.flexslider({
            animation: "slide",
            controlNav: false,
            directionNav: showdirectional,
            prevText: "",
            nextText: "",
            animationLoop: false,
            slideshow: false,
            itemWidth: imagewidth,
            itemMargin: 15,
            before: function(slider){
                if (window.innerWidth < 1250 || maxitems) {
                    var index = slider.animatingTo;
                    //set active
                    slider.slides.removeClass('flex-active-slide').eq(index).addClass('flex-active-slide');
                    //update synced slider
                    $('#quiz-slider').flexslider(index);
                }
            },
            minItems: getGridSize(), // use function to pull in initial value
            maxItems: getGridSize(), // use function to pull in initial value
            move: 1, 
            asNavFor: '#quiz-slider',
            start: function(){
                // BITV/WCAG: Add accessible labels to navigation links
                addQuizNavigationLabels();
                $quizcarousel.removeClass('hide');
                $(window).trigger('resize');
                setTimeout(function(){
                    $(window).trigger('resize');
                    // BITV/WCAG: Re-add labels in case FlexSlider recreates links
                    addQuizNavigationLabels();
                },500);
            },
            after: function(){
                // BITV/WCAG: Re-add labels in case FlexSlider recreates links
                addQuizNavigationLabels();
                $(window).trigger('resize');
            }
        });

        // check grid size on resize event
        $window.resize(function() {
            if( $quizcarousel.length ) {
                var gridSize = getGridSize();

                $quizcarousel.data('flexslider').vars.minItems = gridSize;
                $quizcarousel.data('flexslider').vars.maxItems = gridSize;
            }
            // setTimeout(format_videos,50);

            var vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', vh+'px');
        });



	$('#quiz-slider').flexslider({
	    animation: "slide",
	    directionNav: false,
	    animationLoop: false,
	    slideshow: false,
	    sync: "#quiz-carousel"
	});

	$('.quiz .answer-text').hide();
	$('.quiz .answer').click(function(){
	    var $this = $(this);
	    var question_slide = $this.parents('.question-slide');
	    var right_answer = question_slide.data('right');
	    var isrightanswer = $this.data('isrightanswer'); 

	    $this.parents('.quiz').find('.answer').removeClass('active');
	    $this.addClass('active');
	    // if( $this.data('no') === right_answer ) {
	    if( isrightanswer == 1) {
	        question_slide.find('.slider-wrong-answer').slideUp(500);
	        question_slide.find('.slider-right-answer').slideDown(500);
	    } else {
	        question_slide.find('.slider-right-answer').slideUp(500);
	        question_slide.find('.slider-wrong-answer').slideDown(500);
	    }
	});

	// BITV/WCAG: Ensure navigation labels are added even if FlexSlider creates links later
	setTimeout(function() {
		addQuizNavigationLabels();
	}, 1000);

});